import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'

/**
 * References the available features functionality within the Cube domain.
 * Due to the depth of available features within the Cube domain, there
 * will be a lot more details - especially for phases - in those queries
 * until we port them out into equivalent hooks.
 *
 * Therefore, this serves as a bridge between selectors and the older
 * approach!
 */
export const useAvailableFeatures = () => {
  const ctx = useCubeContext()

  return {
    availableFeatures: ctx.queries.availableFeatures
  }
}
